import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth';
import workspace from './workspace';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    workspace,
  },
});
